import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons'
import Username from './../common/Username';
import Avatar from './../common/Avatar';
import { Link } from 'react-router-dom';

const ActivityFeedQuote = (props) => (
    <li className="media">
        <div className="row">
            <div className="col-xs-2">
                <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
            </div>
            <div className="col-xs-10">
                <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
                <span className="activity-date text-muted"> added a new quote, </span>
                <Link to="/media/quotes/:{props.quote.slug}">"{props.item.quote.title}"</Link>
                <div className="media-left">
                    <FontAwesomeIcon className="text-primary" icon={faQuoteLeft} fixedWidth />
                </div>
                <div className="media-body">
                    <blockquote>
                        <p className="activity-date text-muted">{props.item.quote.body}</p>
                        <small>
                            { props.item.quote.involved.length > 0 ? props.item.quote.involved.map((member) => (
                                <span key={`${member}-quotedmember`}>
                                    <Username user={member}
                                        rank={props.ranks[member.rank]} placement="left"/>
                                    <span> </span>
                                </span>
                                )) : null
                            }
                        </small>
                    </blockquote>
                </div>
            </div>
        </div>
    </li>
);

export default ActivityFeedQuote;


// WEBPACK FOOTER //
// ./src/ActivityFeed/ActivityFeedQuote.js